import DonutChart, { type DonutSlice } from './DonutChart';
import ChartCard from './ChartCard';
import ChartSkeleton from './ChartSkeleton';
import EmptyState from '../EmptyState';
import { CHART_COLORS } from './chartTheme';
import { PieChart as PieChartIcon } from 'lucide-react';

interface PieChartCardProps {
  title: string;
  subtitle?: string;
  data: DonutSlice[];
  loading?: boolean;
  emptyTitle?: string;
  emptyMessage?: string;
  height?: number;
}

function PieChartCard({
  title,
  subtitle,
  data,
  loading = false,
  emptyTitle = 'No data yet',
  emptyMessage,
  height = 260,
}: PieChartCardProps) {
  return (
    <ChartCard title={title} subtitle={subtitle}>
      {loading ? (
        <ChartSkeleton height={height} />
      ) : data.length === 0 ? (
        <EmptyState icon={<PieChartIcon size={28} />} title={emptyTitle} message={emptyMessage} />
      ) : (
        <>
          <DonutChart data={data} height={height} innerRadius={0} outerRadius={96} />
          <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1">
            {data.map((slice, i) => (
              <div key={slice.name} className="flex items-center gap-1.5 text-xs text-zt-muted">
                <span
                  className="h-2 w-2 rounded-full"
                  style={{ backgroundColor: slice.color ?? CHART_COLORS[i % CHART_COLORS.length] }}
                />
                {slice.name}
              </div>
            ))}
          </div>
        </>
      )}
    </ChartCard>
  );
}

export default PieChartCard;
